module.exports = __webpack_public_path__ + "static/media/no-materials.9737baa9.png";